import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./PostDesalterHEX2.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function PostDesalterHEX2() {

    useEffect(() => {
    
      trackPageVisit("PostDesalterHEX2");
    
    }, []);
    
    const {processData,  setProcessData} = useContext(ProcessContext);
    const { toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);

     

  const DEFAULT_VALVES = {
  FCV_15001: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("PostDesalterHEX2_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_15001: { ...DEFAULT_VALVES.FCV_15001, ...parsed.FCV_15001 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PostDesalterHEX2_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};






const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

            const { transmitters, } = usePlantStore();
            const TT_14010 = transmitters.TT_14010 || 0;
            const TT_2005 = transmitters.TT_2005 || 0;
  


  const xv15001Open = !valves?.XV_15001;
  const xv15002Open = !valves?.XV_15002;


  const TT_15001 = TT_14010   // ================= CRUDE INLET TO E-108D
  const TT_15002 = xv15001Open ? 218.654 : 23   // ================= PUMP AROUND INLET TO E-108A
  const TT_15003 = TT_2005;   // ================= DIESEL INLET TO E-109B (TT_2005 ADD THIS LATER)

  

/* =========================================================
   E-108 TAGS
========================================================= */

const TT_15005 = processData.TT_15005;
const TT_15006 = processData.TT_15006;
const TT_15007 = processData.TT_15007;
const TT_15008 = processData.TT_15008;


/* =========================================================
   E-108 REFS
========================================================= */

const E108_intervalRef = useRef(null);
const E108_isMounted = useRef(false);

const TT_15005_Ref =
  useRef(processData.TT_15005 ?? 120);

const TT_15006_Ref =
  useRef(processData.TT_15006 ?? 130);

const TT_15007_Ref =
  useRef(processData.TT_15007 ?? 210);

const TT_15008_Ref =
  useRef(processData.TT_15008 ?? 205);

const E108_processRef = useRef({});


/* =========================================================
   KEEP PROCESS UPDATED
========================================================= */

useEffect(() => {

  E108_processRef.current = {

    TT_15001,
    TT_15002

  };

});


/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  TT_15005_Ref.current =
    TT_15005 ?? TT_15005_Ref.current;

}, [TT_15005]);

useEffect(() => {

  TT_15006_Ref.current =
    TT_15006 ?? TT_15006_Ref.current;

}, [TT_15006]);

useEffect(() => {

  TT_15007_Ref.current =
    TT_15007 ?? TT_15007_Ref.current;

}, [TT_15007]);

useEffect(() => {

  TT_15008_Ref.current =
    TT_15008 ?? TT_15008_Ref.current;

}, [TT_15008]);


/* =========================================================
   E-108 A/B/C/D HEAT EXCHANGER
========================================================= */

useEffect(() => {

  if (E108_isMounted.current)
    return;

  E108_isMounted.current = true;

  console.log(
    "✅ E-108 interval created"
  );

  E108_intervalRef.current =
    setInterval(() => {

      const {

        TT_15001,
        TT_15002

      } = E108_processRef.current;

      const crudeInlet =
        Number(TT_15001) || 0;

      const pumpAroundInlet =
        Number(TT_15002) || 0;

      let crudeOutlet =
        crudeInlet;

      let pumpOutlet =
        pumpAroundInlet;

      const hotter =
        Math.max(
          crudeInlet,
          pumpAroundInlet
        );

      const colder =
        Math.min(
          crudeInlet,
          pumpAroundInlet
        );

      const deltaT =
        hotter - colder;

      if (deltaT > 0.05) {

        /*
          Four exchangers in series
          High effectiveness
        */

        const effectiveness = 0.28;

        const duty = Math.max(

          0.5,

          deltaT *
          effectiveness

        );

        const secondaryDuty =
          duty * 0.72;

        if (
          pumpAroundInlet >= crudeInlet
        ) {

          pumpOutlet =
            pumpAroundInlet -
            duty;

          crudeOutlet =
            crudeInlet +
            secondaryDuty;

          pumpOutlet =
            Math.max(
              pumpOutlet,
              crudeInlet + 0.5
            );

          crudeOutlet =
            Math.min(
              crudeOutlet,
              pumpAroundInlet - 0.5
            );

        }

        else {

          crudeOutlet =
            crudeInlet -
            duty;

          pumpOutlet =
            pumpAroundInlet +
            secondaryDuty;

          crudeOutlet =
            Math.max(
              crudeOutlet,
              pumpAroundInlet + 0.5
            );

          pumpOutlet =
            Math.min(
              pumpOutlet,
              crudeInlet - 0.5
            );

        }

      }

      /*
         Intermediate exchanger temperatures
         (Approximation through four shells)
      */

      const targetTT15005 =
        crudeInlet +
        (crudeOutlet - crudeInlet) *
        0.55;

      const targetTT15006 =
        crudeOutlet;

      const targetTT15007 =
        pumpAroundInlet +
        (pumpOutlet - pumpAroundInlet) *
        0.45;

      const targetTT15008 =
        pumpOutlet;

      /* =====================================
         THERMAL LAG
      ===================================== */

      TT_15005_Ref.current +=

        (
          targetTT15005 -
          TT_15005_Ref.current
        ) * 0.08;

      TT_15006_Ref.current +=

        (
          targetTT15006 -
          TT_15006_Ref.current
        ) * 0.08;

      TT_15007_Ref.current +=

        (
          targetTT15007 -
          TT_15007_Ref.current
        ) * 0.08;

      TT_15008_Ref.current +=

        (
          targetTT15008 -
          TT_15008_Ref.current
        ) * 0.08;

      /* =====================================
         UPDATE PROCESS
      ===================================== */

      setProcessData(prev => ({

        ...prev,

        TT_15005: Number(
          TT_15005_Ref.current.toFixed(2)
        ),

        TT_15006: Number(
          TT_15006_Ref.current.toFixed(2)
        ),

        TT_15007: Number(
          TT_15007_Ref.current.toFixed(2)
        ),

        TT_15008: Number(
          TT_15008_Ref.current.toFixed(2)
        )

      }));

    }, 1000);

  return () => {

    console.log(
      "❌ E-108 interval cleared"
    );

    if (
      E108_intervalRef.current
    ) {

      clearInterval(
        E108_intervalRef.current
      );

      E108_intervalRef.current =
        null;

    }

    E108_isMounted.current =
      false;

  };

}, []);




/* =========================================================
   E-109 TAGS
========================================================= */

const TT_15009 = processData.TT_15009;
const TT_15010 = processData.TT_15010;


/* =========================================================
   E-109 REFS
========================================================= */

const E109_intervalRef = useRef(null);
const E109_isMounted = useRef(false);

const TT_15009_Ref =
  useRef(processData.TT_15009 ?? 145);

const TT_15010_Ref =
  useRef(processData.TT_15010 ?? 170);

const E109_processRef =
  useRef({});


/* =========================================================
   KEEP PROCESS UPDATED
========================================================= */

useEffect(() => {

  E109_processRef.current = {

    TT_15006,
    TT_15003

  };

});


/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  TT_15009_Ref.current =
    TT_15009 ?? TT_15009_Ref.current;

}, [TT_15009]);

useEffect(() => {

  TT_15010_Ref.current =
    TT_15010 ?? TT_15010_Ref.current;

}, [TT_15010]);


/* =========================================================
   E-109 A/B HEAT EXCHANGER
========================================================= */

useEffect(() => {

  if (E109_isMounted.current)
    return;

  E109_isMounted.current = true;

  console.log(
    "✅ E-109 interval created"
  );

  E109_intervalRef.current =
    setInterval(() => {

      const {

        TT_15006,
        TT_15003

      } = E109_processRef.current;

      const crudeInlet =
        Number(TT_15006) || 0;

      const dieselInlet =
        Number(TT_15003) || 0;

      let crudeOutlet =
        crudeInlet;

      let dieselOutlet =
        dieselInlet;

      const hotter =
        Math.max(
          crudeInlet,
          dieselInlet
        );

      const colder =
        Math.min(
          crudeInlet,
          dieselInlet
        );

      const deltaT =
        hotter - colder;

      if (deltaT > 0.05) {

        /*
          Two exchangers in series
        */

        const effectiveness =
          0.24;

        const duty =
          Math.max(
            0.30,
            deltaT *
            effectiveness
          );

        const secondaryDuty =
          duty * 0.72;

        if (
          dieselInlet >= crudeInlet
        ) {

          dieselOutlet =
            dieselInlet -
            duty;

          crudeOutlet =
            crudeInlet +
            secondaryDuty;

          dieselOutlet =
            Math.max(
              dieselOutlet,
              crudeInlet + 0.5
            );

          crudeOutlet =
            Math.min(
              crudeOutlet,
              dieselInlet - 0.5
            );

        }

        else {

          crudeOutlet =
            crudeInlet -
            duty;

          dieselOutlet =
            dieselInlet +
            secondaryDuty;

          crudeOutlet =
            Math.max(
              crudeOutlet,
              dieselInlet + 0.5
            );

          dieselOutlet =
            Math.min(
              dieselOutlet,
              crudeInlet - 0.5
            );

        }

      }

      /* =====================================
         THERMAL LAG
      ===================================== */

      TT_15009_Ref.current +=

        (
          crudeOutlet -
          TT_15009_Ref.current
        ) * 0.08;

      TT_15010_Ref.current +=

        (
          dieselOutlet -
          TT_15010_Ref.current
        ) * 0.08;

      /* =====================================
         UPDATE PROCESS CONTEXT
      ===================================== */

      setProcessData(prev => ({

        ...prev,

        TT_15009: Number(
          TT_15009_Ref.current.toFixed(2)
        ),

        TT_15010: Number(
          TT_15010_Ref.current.toFixed(2)
        )

      }));

    }, 1000);

  return () => {

    console.log(
      "❌ E-109 interval cleared"
    );

    if (
      E109_intervalRef.current
    ) {

      clearInterval(
        E109_intervalRef.current
      );

      E109_intervalRef.current =
        null;

    }

    E109_isMounted.current =
      false;

  };

}, []);



useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_15010 === TT_15010 &&
    current.TT_15009 === TT_15009 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_15010, TT_15009,
    }
  });

}, [TT_15010, TT_15009, ]);



  return (
    <div className="PostDesalterHEX2-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 273px",
          zIndex: 10,
        }}
      >
        POST DESALTER HEATERS 2
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-15001 */}
      <Valve
        className="XV-15001"
        tag="XV_15001"
        x={1109}
        y={106}
        isClosed={valves.XV_15001}
        toggle={toggleValve}
      />


     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          <Transmitter
          tag="TT_15001"
          value={[TT_15001]}
          x={192}
          y={635}
          unit="°C"
          max={200}
          HH={186}
          H={165}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-107A/B TO E-108A/D INLET"
         />

          <Transmitter
          tag="TT_15002"
          value={[TT_15002]}
          x={1148}
          y={95}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND FROM E-302A/B TO E-108A/D INLET"
         />

          <Transmitter
          tag="TT_15003"
          value={[TT_15003]}
          x={1072}
          y={670}
          unit="°C"
          max={300}
          HH={386}
          H={365}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF DIESEL FROM E-110A/B TO E-109A/B INLET"
         />

          <Transmitter
          tag="TT_15005"
          value={[TT_15005]}
          x={512}
          y={280}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-108C/D TO E-108C/D INLET"
         />

          <Transmitter
          tag="TT_15006"
          value={[TT_15006]}
          x={970}
          y={193}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-108A/B/C/D TO E-109A/B INLET"
         />

          <Transmitter
          tag="TT_15007"
          value={[TT_15007]}
          x={252}
          y={280}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND FROM E-108A/B TO E-108C/D INLET"
         />

          <Transmitter
          tag="TT_15008"
          value={[TT_15008]}
          x={152}
          y={703}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND FROM E-108A/B/C/D TO T-102 INLET"
         />

          <Transmitter
          tag="TT_15009"
          value={[TT_15009]}
          x={1102}
          y={602}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-109A/B TO T-101 INLET"
         />

          <Transmitter
          tag="TT_15010"
          value={[TT_15010]}
          x={1142}
          y={262}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-109A/B TO E-105A/B IN POST DESALTER HEX 1"
         />

      





    </div>
  );
}

export default PostDesalterHEX2;